import * as React from 'react';
import { createComponent } from '../core/create-component.js';
import { SecondaryTileLabeledInputContext } from './secondary-tile.context.js';
const SecondaryTileLabeledInput = createComponent({
  displayName: 'SecondaryTileLabeledInput',
  root: 'div',
  propConfig: {
    classNames: ['swan-secondary-tile-labeled-input'],
    derivedProps() {
      const [labelId, setLabelId] = React.useState();
      return {
        labelId,
        setLabelId
      };
    },
    wrapRoot(_props, derivedProps, element) {
      const {
        labelId,
        setLabelId
      } = derivedProps;
      return /*#__PURE__*/React.createElement(SecondaryTileLabeledInputContext.Provider, {
        value: {
          labelId,
          setLabelId
        }
      }, element);
    }
  }
});
export { SecondaryTileLabeledInput };